import {
  Table,
  TBody,
  Td,
  TdFixed,
  Th,
  THead,
  ThFixed,
  Tr
} from "components"
import {
  ButtonDelete,
  ButtonDetail,
  ButtonUpdate,
  DataStatus
} from "components2"
import { ButtonGroup } from "react-bootstrap"

export const ListPerubahanData = ({
  data,
  showDeleteButton = true,
  showUpdateButton = true,
  showDetailButton = false,
  onClickDelete,
  onClickUpdate,
  onClickDetail
}) => {
  return (
    <Table>
      <THead>
        <Tr>
          <ThFixed>No.</ThFixed>
          <ThFixed>Modul</ThFixed>
          <Th>Menu</Th>
          <Th>No. Referensi Transaksi</Th>
          <Th>Detail Perubahan</Th>
          <ThFixed>Aksi</ThFixed>
        </Tr>
      </THead>

      <TBody>
        {data?.length ? data?.map((e, index) => (
          <Tr key={e.id_permintaan_perubahan_data_detail}>
            <TdFixed className="text-center">{index + 1}</TdFixed>
            <Td>{e.kode_modul ?? "-"}</Td>
            <Td>{e.kode_menu ?? "-"}</Td>
            <Td>{e.no_referensi_transaksi ?? "-"}</Td>
            <Td>{generateDetailPerubahan(e)}</Td>
            <TdFixed>
              <ButtonGroup>
                {showUpdateButton ? (
                  <ButtonUpdate
                    icon
                    noText
                    variant="success"
                    onClick={() => onClickUpdate(e, index)}
                  />
                ) : null}

                {showDeleteButton ? (
                  <ButtonDelete
                    icon
                    noText
                    onClick={() => onClickDelete(e, index)}
                  />
                ) : null}

                {showDetailButton ? (
                  <ButtonDetail
                    icon
                    noText
                    variant="primary"
                    onClick={() => onClickDetail(e, index)}
                  />
                ) : null}
              </ButtonGroup>
            </TdFixed>
          </Tr>
        ))
          : (
            <Tr>
              <Td colSpan={11}>
                <DataStatus text="Tidak ada data" />
              </Td>
            </Tr>
          )}
      </TBody>
    </Table>
  )
}

function generateDetailPerubahan(e) {
  return (
    <ul>
      {e.atribut?.map((e, index) => (
        <li key={index}>
          <div style={{ whiteSpace: "pre-line" }}>
            <span>atribut: <strong>{e.atribut_salah}</strong> | </span>
            <span>sebelum: <strong>{e.nilai_sebelum}</strong> | </span>
            <span>sesudah: <strong>{e.nilai_diminta}</strong> | </span>
            <span>alasan: <strong>{e.alasan_pengubahan}</strong></span>
          </div>
        </li>
      ))
      }
    </ul>
  )
}